module.exports = __webpack_public_path__ + "img/side-bg.3da1d202.png";